import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase-config"; // Ensure this path is correct

const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("🔍 Checking Authentication Status..."); // Debugging Log
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log("📌 Auth State Changed:", currentUser); // Debugging Log
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Prevent UI flickering
  }

  if (!user) {
    console.log("❌ Not Authenticated! Redirecting to home...");
    return <Navigate to="/" replace />;
  }

  console.log("✅ Authenticated! Rendering Admin Page.");
  return children;
};

export default ProtectedRoute;
